import { SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'reviews',
    useLayout: true,
    children: [{ id: SectionsKey.Reviews, order: 1, dataKey: SectionsKey.Reviews }]
};

export default PageStruct;
